<template>
  <div class="container-fluid">
    <div class="row">
      <div class="stock-search-bar">
        <button class="barcode-scanner text-white" @click="openTables">
          <font-awesome-icon icon="fa-solid fa-table"/>
        </button>

        <input v-model="input"  @keyup.enter="getStock"
               class="ml-2 stock-search-field form-control"
               placeholder="PLU, Barcode, Description,  Description 2" type="text">

        <button @click="getStock" type="button" class="barcode-scanner mx2 text-white">
          <font-awesome-icon icon="fa-solid fa-magnifying-glass"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StockSearchBar",
  components: {},
  computed: {
    saleUnits() {
      return this.$store.getters.getSaleUnits
    },
    category() {
      return this.$store.getters.getCurrentCategory
    },
    subCategory() {
      return this.$store.getters.getSubCategory
    },
    sub2Category() {
      return this.$store.getters.getSubCategory2
    },
    isTabOpen() {
      return this.$store.getters.getIsTabOpen
    }
  },
  data() {
    return {
      input: '',

    }
  },
  methods: {
    open() {
      this.$router.push({name: 'viewSale'})
    },
    search(e) {
      this.getStock()
    },
    openTables() {
      return this.$router.push({name: 'tables'})
    },
    addScaleItem(itemObj) {
      this.$store.dispatch('getStockSetting', itemObj.PLU).then(async (set) => {
        if (set.cookingLink) {
          this.$router.push({name: 'instruction', params: {plu: itemObj.PLU}})
          return;
        }
        let price = itemObj.SellingIncl;
        let specialPrice = this.$store.getters.getItemSpecialPrice(itemObj.PLU)
        if (specialPrice){
          price = specialPrice;
        }

        let tourismLevy = 0.0;
        if (set.tourism){
          let obj = { amount : price, incl : true }
          tourismLevy = await this.$store.dispatch('getTourismLevyAmount', obj);
        }

        let obj = {
          Plu: itemObj.PLU,
          Description: itemObj.Description,
          Qty: itemObj.Qty,
          Unit: Number(price).toFixed(2),
          Line: Number(price * itemObj.Qty).toFixed(2),
          Discount: 0,
          tourismLevy,
          vat: 0,
          instructions: []
        }
        this.$store.commit('addToCurrentSaleLines', obj)
      }).catch(e => log('An error occurred'))
    },
    addToSale(item) {
      this.$store.dispatch('getStockSetting', item.PLU).then((set) => {
        if (set.cookingLink) {
          this.$router.push({name: 'instruction', params: {plu: item.PLU}})
          return;
        }
        let price = item.SellingIncl;
        let specialPrice = this.$store.getters.getItemSpecialPrice(item.PLU)
        if (specialPrice){
          price = specialPrice;
        }
        let obj = {
          Plu: item.PLU,
          Description: item.Description,
          Qty: 1,
          Unit: Number(price).toFixed(2),
          Line: Number(price).toFixed(2),
          Discount: 0,
          vat: 0,
          instructions: []
        }
        this.$store.commit('addToCurrentSaleLines', obj)
      }).catch(e => log('An error occurred'))
    },
    getStock() {
      this.$utils.showLoading()
      const query = {
        description: this.input,
        category: '',
        subCategory: '',
        sub2Category: ''
      }
      return this.$store.dispatch('searchDescription', query)
          .finally(()=>this.$utils.hideLoading())
    },
  },
}
</script>

<style lang="scss" scoped>
.row {
  background: #0092f7;
  padding: 0 10px;
}

button {
  background: #0092f7;
}

.stock-search-bar {
  background: #92A7BA;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  border-radius: 10px 10px 0 0;
  justify-content: flex-start;
  position: relative;

  .barcode-scanner {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    font-size: 24px;
  }

  .viewOrder {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;

    .badge {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: -10px;
      right: -10px;
      font-size: 8px;
      width: 24px;
      height: 24px;
      background: #0092f7;
      border-radius: 50%;
    }
  }

  .search-icon {
    left: 67px;
    font-size: 18px;
    color: #40434A;
  }

  .stock-search-field {
    margin-left: 10px;
    height: 40px;
    width: 100%;
    border-radius: 10px;
    padding-left: 30px;
    outline: transparent;
  }
}
</style>
